import React from 'react';
import { Card, HeadingText, UtilityText } from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { EASYPLAN_ASSET_KEYS } from '../../../types/easy-plan-asset.types';

export function EasyPlanPerkCardItemsContainer(data: any) {
  const { item } = data;
  const placeHolderImage = useStaticAsset(
    EASYPLAN_ASSET_KEYS.PLACEHOLDER_IMG,
  ) as string;
  return (
    <Card.Flat
      imagePosition="start"
      css={{
        width: '280px',
        height: '72px',
        alignItems: 'center',
        padding: '$none $two',
        '.GDS-c-fLxrLx': {
          padding: '$none $none $none $oneAndHalf',
        },
      }}
    >
      <Card.Image
        image={item.image && item.image !== '' ? item.image : placeHolderImage}
        imageAlt="COB header"
        css={{ width: '32px', alignSelf: 'center' }}
      />
      <Card.Section
        css={{
          '@mobile': {
            padding: '$oneAndHalf $one',
          },
        }}
      >
        <HeadingText
          size="md"
          level="4"
          css={{
            fontSize: '$bodyTwo',
            fontWeight: '$headingOne',
            lineHeight: '$subtitleTwo',
            letterSpacing: '-0.2px',
          }}
        >
          {item.title}
        </HeadingText>
        <UtilityText
          emphasis="subtle"
          css={{
            fontSize: '$bodyTwo',
            fontWeight: '$bodyOne',
            lineHeight: '$subtitleTwo',
          }}
        >
          {item.subtitle}
        </UtilityText>
      </Card.Section>
    </Card.Flat>
  );
}
